export class ConnectAzureBackupAccountRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "subscriptionId",
            "baseName": "subscriptionId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "adxClusterId",
            "baseName": "adxClusterId",
            "type": "string",
            "format": ""
        },
        {
            "name": "adxClusterUri",
            "baseName": "adxClusterUri",
            "type": "string",
            "format": ""
        },
        {
            "name": "adxIdentity",
            "baseName": "adxIdentity",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "federatedManagedIdentityResourceId",
            "baseName": "federatedManagedIdentityResourceId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ConnectAzureBackupAccountRequest.attributeTypeMap;
    }
    constructor() {
    }
}
